import { query as fbQuery, collection, where, onSnapshot, doc, orderBy, limit } from "firebase/firestore";
import { db } from "./firebase.utils";

// League reads. Layout: bball_01/functions/src/lib/paths.js

// Listens to a whole collection. Calls e.callback({id: data}) on every
// change, including when the collection is empty.
export function listenToCollection(e) {
    const unsub = onSnapshot(collection(db, e.path), snap => {
        const docs = {};
        snap.forEach(d => { docs[d.id] = d.data(); });
        e.callback(docs);
    }, err => {
        console.log(e.path, err);
        e.callback({});
    });
    e.handleListener(unsub);
}

// Listens to one document, e.g. `leagues/${id}/summary/teams`. Calls
// e.callback(data) on every change (null if it doesn't exist).
export function listenToDoc(e) {
    const unsub = onSnapshot(doc(db, e.path), snap => {
        e.callback(snap.exists() ? snap.data() : null);
    }, err => {
        console.log(e.path, err);
        e.callback(null);
    });
    e.handleListener(unsub);
}

// The latest e.limit news days of a league (leagues/{id}/news), newest
// first. Calls e.callback([day]) on every change.
export function listenToNews(e) {
    const q = fbQuery(collection(db, `leagues/${e.leagueId}/news`), orderBy('key', 'desc'), limit(e.limit));
    const unsub = onSnapshot(q, snap => {
        e.callback(snap.docs.map(d => d.data()));
    }, err => {
        console.log('news', err);
        e.callback([]);
    });
    e.handleListener(unsub);
}

// Leagues where e.appId manages a team. Calls e.callback({leagueId:
// league}) on every change.
export function listenToMyLeagues(e) {
    const q = fbQuery(collection(db, 'leagues'), where('managerIds', 'array-contains', e.appId));
    const unsub = onSnapshot(q, snap => {
        const docs = {};
        snap.forEach(d => { docs[d.id] = d.data(); });
        e.callback(docs);
    }, err => {
        console.log('my leagues', err);
        e.callback({});
    });
    e.handleListener(unsub);
}
